export default "__VITE_ASSET__64f5cf0d__"